var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { style: { fontSize: _vm.fontSize, fontWeight: _vm.fontWeight } },
    [
      _vm.showAddOrSub
        ? _c("span", [_vm._v(_vm._s(_vm.counter >= 0 ? "+" : "-"))])
        : _vm._e(),
      _c("span", { on: { click: _vm.doClick } }, [
        _vm._v(_vm._s(_vm.realCounter)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }